import React from 'react';

export default function VehicleReport() {
  return <div>Vehicle Report form</div>;
}
